export default "__VITE_ASSET__BXJxtWJV__"